import type { CoreQuestionResource } from '@dmp/qqms/data-access';
import type { StoreState } from '../../state-types';

/** Update core question partially */
export const updateCoreQuestion =
    (
        coreQuestionId: string,
        partialCoreQuestion: Partial<CoreQuestionResource>
    ) =>
    (state: StoreState): StoreState => {
        return {
            ...state,
            coreQuestions: {
                ...state.coreQuestions,
                [coreQuestionId]: {
                    ...state.coreQuestions[coreQuestionId],
                    ...partialCoreQuestion,
                },
            },
        };
    };
